<app-pcbread-crumb [data]="'Reports,InsuranceReport'"></app-pcbread-crumb>

<div class="card p-2 animate__animated animate__backInDown">
  <div class="row">
    <div
      class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 col-xxl-4 mb-2 padding-mobile-size"
    >
      <div class="row input-box drug-information-box mt-3 mx-1 p-2 mb-2">
        <div class="col-12 mb-1">
          <div class="input-box-title-box px-2">
            <span>{{ "ReportInformation" | translate : "" }}</span>
          </div>
          <div class="edit-form">
            <label class="form-label m-0">
              {{ "PrescriptionDate" | translate }}
            </label>
            <div
              class="input-group input-daterange"
              id="bs-datepicker-daterange"
            >
              <span class="input-group-text label-span">
                {{ "From" | translate }}
              </span>
              <input
                type="text"
                id="startDate"
                autocomplete="off"
                placeholder="YYYY/MM/DD"
                appSelectOnFocus
                appConvertNumbers
                [ngModel]="backendJson.startDate | dataType : '' : false"
                class="form-control"
                [ngbPopover]="popoverPrescriptionDateFromDatePicker"
                [autoClose]="'outside'"
                #datePicker="ngbPopover"
                (ngModelChange)="
                  backendJson.startDate = calendarService.TypeDate('startDate')
                "
              />
              <ng-template #popoverPrescriptionDateFromDatePicker>
                <app-data-picker
                  [(childProp)]="backendJson.startDate"
                  (changeVariableMonth)="changeMonth($event)"
                ></app-data-picker>
              </ng-template>
              <button
                class="input-group-text"
                [ngbPopover]="popoverPrescriptionDateFromDatePicker"
                [autoClose]="'outside'"
                #datePicker="ngbPopover"
              >
                <i class="far fa-calendar-alt"></i>
              </button>

              <span class="input-group-text label-span">
                {{ "To" | translate }}
              </span>

              <input
                type="text"
                id="endDate"
                autocomplete="off"
                placeholder="YYYY/MM/DD"
                appSelectOnFocus
                appConvertNumbers
                [ngModel]="backendJson.endDate | dataType : '' : false"
                class="form-control"
                [ngbPopover]="popoverPrescriptionDateToDatePicker"
                [autoClose]="'outside'"
                #datePicker="ngbPopover"
                (ngModelChange)="
                  backendJson.endDate = calendarService.TypeDate('endDate')
                "
              />
              <ng-template #popoverPrescriptionDateToDatePicker>
                <app-data-picker
                  [(childProp)]="backendJson.endDate"
                  (changeVariableMonth)="changeMonth($event)"
                ></app-data-picker>
              </ng-template>
              <button
                class="input-group-text"
                [ngbPopover]="popoverPrescriptionDateToDatePicker"
                [autoClose]="'outside'"
                #datePicker="ngbPopover"
              >
                <i class="far fa-calendar-alt"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="col-12 mb-1">
          <div class="edit-form">
            <label class="form-label m-0">
              {{ "FishType" | translate }}
            </label>
            <select
              class="form-select input-select-text py-2 Focusable iner-Focusable w-100"
              [(ngModel)]="backendJson.insuranceId"
            >
              <option
                *ngFor="let insurance of insuranceList"
                [ngValue]="insurance.id"
              >
                {{ insurance.persianName }}
              </option>
            </select>
          </div>
        </div>

        <div class="col-12 mt-2">
          <div
            class="btn-group w-100"
            role="group"
            aria-label="Button group with nested dropdown"
          >
            <div class="btn-group w-100" role="group">
              <button
                id="btnGroupDrop1"
                type="button"
                class="btn btn-outline-primary dropdown-toggle w-100"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                {{ "ReportTypes" | translate }}
              </button>
              <div
                class="dropdown-menu w-100"
                aria-labelledby="btnGroupDrop1"
                style=""
              >
                <button
                  type="button"
                  class="dropdown-item"
                  (click)="GetPrint()"
                >
                  <i class="bx bx-printer"></i>
                  {{ "GetReportPrint" | translate }}
                </button>
                <button
                  type="button"
                  class="dropdown-item"
                  (click)="GetPrint()"
                >
                  <i class="bx bxs-printer"></i>
                  {{ "GetDetailReportPrint" | translate }}
                </button>
                <button
                  type="button"
                  class="dropdown-item"
                  (click)="GetReport()"
                >
                  <i class="bx bx-check"></i>
                  {{ "GetReport" | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- </div> -->
      </div>
    </div>
    <div
      class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 col-xxl-8"
      *ngIf="totalReport"
    >
      <div
        id="total-report-box"
        class="row input-box finance-box mt-3 mx-1 p-2 pb-4 mb-2 h-auto animate__animated animate__backInDown"
      >
        <div class="col-12 col-lg-4 col-xl-4 p-0">
          <div class="input-box-title-box px-2">
            <span>{{ "PriceFilter" | translate : "" }}</span>
          </div>
          <div class="report-box p-2 mt-2 w-100">
            <label> {{ "startDate" | translate }}</label>
            <span>{{ totalReport.startDate | dataType : "" }}</span>
          </div>
          <div class="report-box p-2 mt-2 w-100">
            <label> {{ "endDate" | translate }}</label>
            <span>{{ totalReport.endDate | dataType : "" }}</span>
          </div>
          <div class="report-box p-2 mt-2 w-100">
            <label> {{ "insuranceName" | translate }}</label>
            <span>{{ totalReport.insuranceName | dataType : "" }}</span>
          </div>
          <div class="report-box p-2 mt-2 w-100">
            <label> {{ "totalInsurancePrice" | translate }}</label>
            <span>{{
              totalReport.totalInsurancePrice | dataType : "price"
            }}</span>
          </div>
        </div>
        <div class="col-12 col-lg-4 col-xl-4 px-1">
          <div class="report-box p-2 mt-2 w-100">
            <label> {{ "totalInsuranceTechnicalRight" | translate }}</label>
            <span>{{
              totalReport.totalInsuranceTechnicalRight | dataType : "price"
            }}</span>
          </div>
          <div class="report-box p-2 mt-2 w-100">
            <label> {{ "totalElementPrice" | translate }}</label>
            <span>{{
              totalReport.totalElementPrice | dataType : "price"
            }}</span>
          </div>
          <div class="report-box p-2 mt-2 w-100">
            <label> {{ "totalPaidPrice" | translate }}</label>
            <span>{{ totalReport.totalPaidPrice | dataType : "price" }}</span>
          </div>
          <div class="report-box p-2 mt-2 w-100">
            <label> {{ "totalShareCurrencyPrice" | translate }}</label>
            <span>{{
              totalReport.totalShareCurrencyPrice | dataType : "price"
            }}</span>
          </div>
        </div>
        <div class="col-12 col-lg-4 col-xl-4 p-0">
          <div class="report-box p-2 mt-2">
            <label> {{ "totalSaleFactorDetailsCount" | translate }}</label>
            <span>{{
              totalReport.totalSaleFactorDetailsCount | dataType : ""
            }}</span>
          </div>
          <div class="report-box p-2 mt-2">
            <label> {{ "detailsCount" | translate }}</label>
            <span>{{ totalReport.detailsCount | dataType : "" }}</span>
          </div>
          <div class="report-box p-2 mt-2">
            <label> {{ "totalPrescriptionsCount" | translate }}</label>
            <span>{{
              totalReport.totalPrescriptionsCount | dataType : ""
            }}</span>
          </div>
        </div>
      </div>
    </div>

    <app-loading-panel *ngIf="loading"></app-loading-panel>
  </div>
</div>
